export const version = '2.69.1';
//# sourceMappingURL=version.js.map